/**
 * The two faces of a copy button: the pair of sheets, and the tick it turns
 * into for a moment once the text is on the clipboard.
 *
 * Shared, because the generate page and the canvas both copy a prompt, and
 * the same action should wear the same mark in both places.
 */
export function CopyGlyph() {
  return (
    <svg viewBox="0 0 16 16" width="13" height="13" aria-hidden="true">
      <rect
        x="5.9"
        y="5.9"
        width="7.4"
        height="7.4"
        rx="1.6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.3"
      />
      <path
        d="M10.4 3.6H4.3a1.6 1.6 0 0 0-1.6 1.6v6.1"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function TickGlyph() {
  return (
    <svg viewBox="0 0 16 16" width="13" height="13" aria-hidden="true">
      <path
        d="m3.5 8.4 3 3 6-6.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
